import { observable, action } from "mobx";
import { httpClient } from "../utils/httpClient";
import api from "../config/api"
const { project } = api

class ProjectStore {

  // 获取列表
  @observable projectList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      pageNo: 1
    }
  }
  @action async getProjectList(params) {
    const { data } = await httpClient.post(project.GET_LIST, { ...params })

    data && (this.projectList = {
      list: data.list.map(item => ({
        ...item,
        key: item.id,
        costPerPersonDay: item.costPerPersonDay / 100,
        customerPayCost: item.customerPayCost / 100,
        developTotalCost: item.developTotalCost / 100,
        otherCost: item.otherCost / 100,
      })),
      pages: {
        total: data.total,
        pageSize: data.pageSize,
        pageNo: data.page
      }
    })
  }

  // 添加或编辑项目
  @action async addOrEditProject(params) {
    const res = await httpClient.post(project.ADD_OR_EDIT_PROJECT, { ...params })

    return res
  }

  // 对项目删除、取消、暂停、评审等
  @action async operateProject(params) {
    const res = await httpClient.post(project.OPERATE_PROJECT, { ...params })

    return res
  }

  // 获取列表
  // @observable statisticsData = []
  @action async getStatisticsData(params) {
    const { data = [] } = await httpClient.post(project.GET_STATISTICS_DATA, { ...params })
    const newData = []
    data.forEach(item => {
      newData.push({
        '月份': item.month.toString(),
        '项目数量': item.completeNumber,
        'name': '已完成的数量',
      })
      newData.push({
        '月份': item.month.toString(),
        '项目数量': item.developingNumber,
        'name': '开发中的数量',
      })
      newData.push({
        '月份': item.month.toString(),
        '项目数量': item.testingNumber,
        'name': '测试中的数量',
      })
      newData.push({
        '月份': item.month.toString(),
        '项目数量': item.pausedNumber,
        'name': '暂停的数量',
      })
      newData.push({
        '月份': item.month.toString(),
        '项目数量': item.canceledNumber,
        'name': '取消的数量',
      })
      
    })
    return newData
  }

}

export default new ProjectStore();
